module.exports = __webpack_public_path__ + "img/i_btn_chat_w.6c3b750d.svg";